export enum JobStatus {
  PENDING = 0,
  COMPLETED = 1,
  IN_PROGRESS = 2,
  CANCELLED = 3,
}
